import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Link } from 'gatsby'
import { Section, Markdown } from '..'
import * as styles from './styles'

const propTypes = {
  path: PropTypes.string.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    introduction: PropTypes.string.isRequired,
    goal: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    endpoints: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  color: PropTypes.string
}

const defaultProps = {
  color: '#000'
}

export default function ExampleGalleryCard({ data, color, path }) {
  return (
    <styles.Container>
      <styles.Card color={color}>
        <Row>
          <Col md={8} sm={12} xs={12}>
            <styles.CardHeader>{data.title}</styles.CardHeader>
            <styles.Introduction>
              {data.introduction}
            </styles.Introduction>
          </Col>
          <Section>
            <Col md={4} sm={12} xs={12}>
              <styles.InfoHeader>GOAL</styles.InfoHeader>
              <styles.InfoText>{data.goal}</styles.InfoText>
              <styles.InfoHeader>ENDPOINTS</styles.InfoHeader>
              <styles.InfoText>
                {_.map(data.endpoints, endpoint => (
                  <styles.Endpoint key={endpoint}>
                    <Markdown>
                      {endpoint}
                    </Markdown>
                  </styles.Endpoint>
                ))}
              </styles.InfoText>
            </Col>
          </Section>
        </Row>
        <styles.LinkRow>
          <Link to={path}>
            Read more
            <styles.Chevron />
          </Link>
        </styles.LinkRow>
      </styles.Card>
    </styles.Container>
  )
}

ExampleGalleryCard.propTypes = propTypes
ExampleGalleryCard.defaultProps = defaultProps
